// Native push types -> web routes. Mirrors src/middleware/pushRoutes.js on the API.
// Only ids matching an ObjectId and types listed here can ever produce a route.
const OBJECT_ID = /^[a-fA-F0-9]{24}$/;

export const NATIVE_ROUTES = {
  work_order_incoming: id => `/work-order/incoming/view/${id}`,
  work_order_outgoing: id => `/work-order/outgoing/view/${id}`,
  work_order_approval: id => `/work-order/approval/view/${id}`,
  work_order_completed: id => `/work-order/completed/view/${id}`,
  work_order_bill: id => `/work-order/view-bill/view/${id}`,
  service_request_incoming: id => `/service-request/incoming/view/${id}`,
  service_request_outgoing: id => `/service-request/outgoing/view/${id}`,
  service_request_observation: id => `/service-request/incoming/observation/view/${id}`,
  purchase_order_incoming: id => `/purchase-order/view/incoming/${id}`,
  purchase_order_outgoing: id => `/purchase-order/view/outgoing/${id}`,
  purchase_order_approval: id => `/purchase-order/view/approval/${id}`,
  purchase_order_invoice: id => `/purchase-order/view-invoice/${id}`,
  purchase_order_supply: id => `/purchase-order/view-supply/${id}`,
  material_request_incoming: id => `/material-request/view/incoming/${id}`,
  material_request_outgoing: id => `/material-request/view/outgoing/${id}`,
  asset_fault: id => `/asset/faults/${id}`,
  asset_assigned: id => `/asset/view/assigned/${id}`,
  asset_view: id => `/asset/view/asset/${id}`,
  verification_tasks: id => `/verification/campaigns/${id}/tasks`
};

export function resolveNativeRoute(target) {
  if (!target || typeof target.type !== "string" || typeof target.id !== "string") return null;
  if (!Object.prototype.hasOwnProperty.call(NATIVE_ROUTES, target.type)) return null;
  if (!OBJECT_ID.test(target.id)) return null;
  return NATIVE_ROUTES[target.type](target.id);
}

const EXPO_TOKEN = /^Expo(nent)?PushToken\[[A-Za-z0-9_-]{10,100}\]$/;

export function isExpoPushToken(value) {
  return typeof value === "string" && EXPO_TOKEN.test(value);
}
